// extracted by mini-css-extract-plugin
export default {"boonBtn":"Button_boonBtn__LEiRi"};